import { Button } from "@rockr/rock-ui"
import React from "react"
import { CustomIcon } from "../CustomIcon"
import { TableContainer, TableRow, TableHeader, TableData } from "../Table"

type Props = {
  signers: any[],
  typeSigners: any[],
  removeSigner: (index: number) => any
}


export const SignersTable: React.FC<Props> = (props) => {
  const {
    signers,
    typeSigners,
    removeSigner
  } = props

  const getTypeName = (typeId: number) => {
    return typeSigners.find(t => t.id === typeId).description
  }

  const renderSigners = () => signers.map((signer, index) => (
    <TableRow key={index}>
      <TableData align="left">{signer.email}</TableData>
      <TableData align="left">{getTypeName(signer.typeId)}</TableData>
      <TableData align="center">
        <Button type="button" bg="none" onClick={() => {
          removeSigner(index)
        }}>
          <CustomIcon name='trash' boxSize="20px"/>
        </Button>
      </TableData>
    </TableRow>
  ))

  return (
    <TableContainer fullWidth>
      <TableRow>
        <TableHeader label="Signer e-mail" align="left"/>
        <TableHeader label="Type" align="left" />
        <TableHeader label="" align="center" />
      </TableRow>

      {renderSigners()}
    </TableContainer>
  )
}
